import type { CrowdexSavedAgent } from '@crowdex/agent-contracts';
import { apiFetch } from '@crowdex/host-kit/renderer/http';

/** The account's reusable agent profiles (`/api/agent-profiles`). */
export async function readAccountAgentProfiles(): Promise<CrowdexSavedAgent[]> {
  return (await apiFetch<{ profiles: CrowdexSavedAgent[] }>('/api/agent-profiles')).profiles;
}

export function replaceAccountAgentProfiles(
  profiles: readonly CrowdexSavedAgent[],
): Promise<CrowdexSavedAgent[]> {
  return apiFetch<CrowdexSavedAgent[]>('/api/agent-profiles', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profiles),
  });
}
